import React, { createContext, useContext, useState } from 'react';

const translations = {
  en: {
    brand_tagline: "Real People, Real Deals",
    search_placeholder: "Search for products, services...",
    login: "Login",
    logout: "Logout",
    dashboard: "Dashboard",
    wishlist: "Wishlist",
    admin_panel: "Admin Panel",
    post_ad: "Post Ad",
    get_started: "Get Started",
    latest_listings: "Latest Listings",
    ready_to_sell: "Ready to Sell?",
    choose_plan: "Choose a plan that fits your needs",
    view_plans: "View Plans",
    footer_text: "India's trusted classified platform",
    no_image: "No Image",
    views: "views",
    posted: "Posted",
    ad_id: "Ad ID",
    report_ad: "Report Ad",
    share: "Share",
    make_offer: "Make Offer",
    contact_seller: "Chat with Seller",
    save: "Save",
    saved: "Saved",
    disclaimer: "Disclaimer: GenzoX is only a platform facilitator. We do not guarantee the authenticity, quality, or condition of any product listed. Please verify items before purchase. All transactions are at your own risk.",
    safety_tips: "Safety Tips",
    meet_safe: "Meet in a safe, public place",
    check_item: "Check the item before you buy",
    pay_after: "Pay only after collecting the item",
    never_share: "Never share OTP, bank details, or personal info",
    categories: "Categories",
    electronics: "Electronics",
    mobiles: "Mobiles",
    cars: "Cars",
    property: "Property",
    fashion: "Fashion",
    furniture: "Furniture",
    bikes: "Bikes",
    books: "Books",
    messages: "Messages",
    send: "Send",
    type_message: "Type a message...",
    offer_price: "Offer Price",
    submit_offer: "Submit Offer",
    suspicious_alert: "This message may contain suspicious content. Never share personal or financial information.",
    block_user: "Block User",
    report_user: "Report User",
    english: "English",
    hindi: "Hindi",
    language: "Language"
  },
  hi: {
    brand_tagline: "असली लोग, असली सौदे",
    search_placeholder: "उत्पाद, सेवाएं खोजें...",
    login: "लॉगिन",
    logout: "लॉगआउट",
    dashboard: "डैशबोर्ड",
    wishlist: "विशलिस्ट",
    admin_panel: "एडमिन पैनल",
    post_ad: "विज्ञापन दें",
    get_started: "शुरू करें",
    latest_listings: "नवीनतम विज्ञापन",
    ready_to_sell: "बेचने के लिए तैयार?",
    choose_plan: "अपनी ज़रूरत के अनुसार प्लान चुनें",
    view_plans: "प्लान देखें",
    footer_text: "भारत का विश्वसनीय क्लासिफाइड प्लेटफॉर्म",
    no_image: "कोई छवि नहीं",
    views: "व्यूज",
    posted: "पोस्ट किया",
    ad_id: "विज्ञापन आईडी",
    report_ad: "विज्ञापन रिपोर्ट करें",
    share: "शेयर करें",
    make_offer: "ऑफर करें",
    contact_seller: "विक्रेता से चैट करें",
    save: "सेव करें",
    saved: "सेव किया",
    disclaimer: "अस्वीकरण: GenzoX केवल एक प्लेटफॉर्म सुविधाकर्ता है। हम किसी भी सूचीबद्ध उत्पाद की प्रामाणिकता, गुणवत्ता या स्थिति की गारंटी नहीं देते। कृपया खरीदने से पहले सामान की जांच करें। सभी लेनदेन आपके अपने जोखिम पर हैं।",
    safety_tips: "सुरक्षा टिप्स",
    meet_safe: "सुरक्षित, सार्वजनिक स्थान पर मिलें",
    check_item: "खरीदने से पहले सामान जांचें",
    pay_after: "सामान लेने के बाद ही भुगतान करें",
    never_share: "कभी भी OTP, बैंक विवरण या व्यक्तिगत जानकारी साझा न करें",
    categories: "श्रेणियाँ",
    electronics: "इलेक्ट्रॉनिक्स",
    mobiles: "मोबाइल",
    cars: "कारें",
    property: "प्रॉपर्टी",
    fashion: "फैशन",
    furniture: "फर्नीचर",
    bikes: "बाइक",
    books: "किताबें",
    messages: "संदेश",
    send: "भेजें",
    type_message: "संदेश लिखें...",
    offer_price: "ऑफर मूल्य",
    submit_offer: "ऑफर भेजें",
    suspicious_alert: "इस संदेश में संदिग्ध सामग्री हो सकती है। कभी भी व्यक्तिगत या वित्तीय जानकारी साझा न करें।",
    block_user: "उपयोगकर्ता ब्लॉक करें",
    report_user: "उपयोगकर्ता रिपोर्ट करें",
    english: "अंग्रेजी",
    hindi: "हिंदी",
    language: "भाषा"
  }
};

const LanguageContext = createContext(null);

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLanguage must be used within LanguageProvider');
  return context;
};

export const LanguageProvider = ({ children }) => {
  // iter63 — Hindi removed until translations are production-ready. Locked to English.
  const [lang] = useState('en');
  const setLang = () => {};
  const t = (key) => translations.en[key] || key;
  const toggleLang = () => {};
  return (
    <LanguageContext.Provider value={{ lang, setLang, t, toggleLang }}>
      {children}
    </LanguageContext.Provider>
  );
};
